import Enumerator from '../global/Enumerator';

export const liabilityTypes = [
  'mortgage_loan',
  'credit_card',
  'overdraft',
  'vehicle_loan',
  'personal_loan',
  'SMSF_loan',
  'education_debt',
  'other',
  'balance_sheet'
];

export class LiabilityType extends Enumerator {
  static default() {
    return this.of('mortgage_loan');
  }
}

LiabilityType.initEnum({
  mortgage_loan: {
    get id() {
      return 'mortgage_loan';
    },
    get title() {
      return 'Mortgage loan';
    },
    get weight() {
      return 1;
    }
  },
  credit_card: {
    get id() {
      return 'credit_card';
    },
    get title() {
      return 'Credit card';
    },
    get weight() {
      return 2;
    }
  },
  overdraft: {
    get id() {
      return 'overdraft';
    },
    get title() {
      return 'Overdraft';
    },
    get weight() {
      return 3;
    }
  },
  vehicle_loan: {
    get id() {
      return 'vehicle_loan';
    },
    get title() {
      return 'Vehicle loan';
    },
    get weight() {
      return 4;
    }
  },
  personal_loan: {
    get id() {
      return 'personal_loan';
    },
    get title() {
      return 'Personal loan';
    },
    get weight() {
      return 5;
    }
  },
  SMSF_loan: {
    get id() {
      return 'SMSF_loan';
    },
    get title() {
      return 'SMSF loan';
    },
    get weight() {
      return 6;
    }
  },
  education_debt: {
    get id() {
      return 'education_debt';
    },
    get title() {
      return 'Student loan';
    },
    get weight() {
      return 7;
    }
  },
  other: {
    get id() {
      return 'other';
    },
    get title() {
      return 'Other';
    },
    get weight() {
      return 8;
    }
  },
  balance_sheet: {
    get id() {
      return 'balance_sheet';
    },
    get title() {
      return 'Balance sheet';
    },
    get weight() {
      return 9;
    }
  }
});

export default {
  liabilityTypes,
  LiabilityType
};
